import { createContext, PropsWithChildren, useCallback, useContext, useRef, useState } from 'react'

import { InstallAppAlert } from 'features/app/InstallAppAlert'

type ShowAppRequiredContext = () => Promise<boolean>

const AppRequiredOverlayContext = createContext<ShowAppRequiredContext | undefined>(undefined)

const AppRequiredOverlayComponent: React.FC<PropsWithChildren> = ({ children }) => {
  const [show, setShow] = useState<boolean>(false)
  const hideOverlay = useCallback(() => {
    setShow(false)
  }, [setShow])
  const resolveRef = useRef<(value: boolean) => void>()

  const showAppRequiredOverlay = (): Promise<boolean> => {
    setShow(true)
    return new Promise((resolve) => {
      resolveRef.current = resolve
    })
  }

  return (
    <AppRequiredOverlayContext.Provider value={showAppRequiredOverlay}>
      {children}
      {show && (
        <div
          className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex justify-center items-center z-50"
          onClick={hideOverlay}
        >
          <div className="bg-white rounded-lg p-6" onClick={(e) => e.stopPropagation()}>
            <InstallAppAlert onClose={hideOverlay} />
          </div>
        </div>
      )}
    </AppRequiredOverlayContext.Provider>
  )
}

export const AppRequiredOverlay = AppRequiredOverlayComponent

export const useShowAppRequiredOverlay = () => {
  const context = useContext(AppRequiredOverlayContext)
  if (!context) {
    throw new Error('useAppRequiredOverlay must be used within a AppRequiredOverlay')
  }
  return context
}
